module.exports = __webpack_public_path__ + "img/sld_promo_pic.4b24b902.png";